RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.CompanyAdd = Backbone.Model.extend({
        url: function () {
            if (this.landscapeId) {
                return `/api/company?landscapeId=${this.landscapeId}`;
            } else {
                return '/api/company';
            }
        },
        setLandscapeId: function (id) {
            this.landscapeId = id;
        }
    });

});
